import styled from 'styled-components'

export const ContainerUpload = styled.div`
  border: 2px dashed #5da57d;
  min-height: 40px; /* Alterado para min-height caso o nome do arquivo seja longo */
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.3s ease;
  width: 100%;
  gap: 10px;
  color: #5da57d;

  &:hover {
    background-color: #f6ffed;
    transition: 0.5s;
    transform: scale(1.01);
  }

  &[data-dragging='true'] {
    background-color: rgba(110, 165, 134, 0.1);
    border-style: solid;
    transform: scale(1.03);
  }

  /* Estágio quando já tem arquivo */
  &[data-has-files='true'] {
    border-style: solid;
    background-color: #f0f9f4;
  }

  span {
    font-size: 13px;
    color: #5da57d;
    margin: 0;
    padding: 0;
    display: inline-flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
  }
`

export const FileIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: center;

  .success-icon {
    color: #27ae60;
  }

  span {
    font-weight: 600;
  }
`